"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const cookieCategories = [{
  id: "technical",
  title: "Cookie Tecnici",
  description: "Questi cookie sono strettamente necessari per il corretto funzionamento del sito web. Ti permettono di navigare e utilizzare le funzionalità fondamentali, come l'accesso alle aree sicure e la gestione del carrello. Senza questi cookie, i servizi essenziali non possono essere forniti. Essendo indispensabili, non richiedono il tuo consenso preventivo per essere installati."
}, {
  id: "analytical",
  title: "Cookie Analitici",
  description: "Utilizziamo questi cookie per comprendere meglio come i visitatori interagiscono con il nostro sito web. Ci aiutano a raccogliere informazioni in forma aggregata su metriche quali il numero di visitatori, le pagine più visitate, il tempo trascorso sul sito e le fonti di traffico. Questi dati ci permettono di misurare e migliorare continuamente le prestazioni e l'esperienza utente del nostro sito."
}, {
  id: "marketing",
  title: "Cookie di Marketing e Profilazione",
  description: "Questi cookie vengono utilizzati per tracciare i visitatori attraverso i siti web. L'obiettivo è quello di creare un profilo dei tuoi interessi per poterti mostrare annunci pubblicitari pertinenti, coinvolgenti e personalizzati. Vengono utilizzati anche per limitare il numero di volte in cui vedi un determinato annuncio e per misurare l'efficacia delle campagne pubblicitarie."
}];
export default function CookieCategories() {
  return <section id="cookie-categories" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="mb-12 text-center">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-primary mb-4">
            Le Nostre Categorie di Cookie
          </h2>
          <p className="font-sans text-muted-foreground max-w-2xl mx-auto text-lg">
            Trasparenza e chiarezza sono fondamentali per noi. Scopri nel dettaglio
            le diverse tipologie di cookie che utilizziamo per offrirti la migliore
            esperienza possibile.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {cookieCategories.map((category, i) => <AccordionItem key={category.id} value={category.id} data-index={i} className="border-b border-ring data-[state=open]:bg-secondary/40 transition-colors duration-500 rounded-t-md px-4 sm:px-6">
              <AccordionTrigger className="font-serif text-2xl text-primary hover:no-underline group py-6">
                <span className="relative inline-block transition-transform duration-300 group-hover:-translate-y-0.5">
                  {category.title}
                  <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-ring transition-all duration-300 group-hover:w-full"></span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="font-sans text-base text-foreground/80 leading-relaxed pb-8 pt-2">
                {category.description}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}